
const fish = {
    state: {
        guide:-1
    },
    getters: {
        getfish(state: { guide: number; }){
            const advStr = localStorage.getItem('guide')
            if (advStr === null) {
                return state.guide
            }
            return JSON.parse(advStr)
        }
    },
    mutations: {
        setfish(state: { guide: number; }, info:string){
            state.guide = Number(info)
        }
    },
    actions: {
        loaclfish(context: { commit: (arg0: string, arg1: string) => void; }, info:string){
            context.commit('setfish', String(info))
            localStorage.setItem('guide', String(info)) 
        }
    }
};


export default fish;